module.exports = __webpack_public_path__ + "img/me.505ef943.jpg";